<dt-modal-content [showFooter]="false" [flexContent]="true" size="small" [contentPadding]="false" (closeClick)="close()">
  <ng-template #title> {{ data.name }} </ng-template>
  <ng-template #subtitle>
    @if (data.subName) {
      {{ data.subName }}
    }
  </ng-template>

  <ng-template #content>
    <dt-team-comments [object]="{ uuid: data.objectUUID }" [firstUnreadCommentId]="data.firstUnreadCommentId"></dt-team-comments>
  </ng-template>
</dt-modal-content>
